import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import bg from './locales/bg.json';
import en from './locales/en.json';

i18n
	.use(initReactI18next)
	.init({
		lng: 'en',
		fallbackLng: 'en',
		resources: {
			en: { translation: en },
			bg: { translation: bg },
		},
		ns: ['translation'],
		defaultNS: 'translation',
		interpolation: {
			escapeValue: false,
		},
		react: { useSuspense: false },
	})
	.then(() => {
		console.log('i18n init ✅');
	});

export default i18n;
